// extracted by mini-css-extract-plugin
export default {"order":"order-confirm_order__lTUwK","id":"order-confirm_id__MK9nZ","img":"order-confirm_img__Ykuoa"};